var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"category",class:{
      selected: category.id===_vm.selected,
      animating: _vm.animating===category.id
    },on:{"click":function($event){return _vm.select(category.id)}}},[_c('img',{attrs:{"src":category.icon}}),_vm._v(" "+_vm._s(_vm.label(category))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }